<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N0Uyh9/tc-custom/9781667451008.jpg?1680421233740" alt="This image is the cover for the book Le Roi Gros Bédonnant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Le Roi Gros Bédonnant
      </h1>
      <p class="bookDescription body article font2">
        <p>Le petit conte enfantin Le Roi Gros Bedonnant utilise les légumes pour représenter les personnages principaux dans le décor d'une table de cuisine, en stimulant les enfants à peupler son monde magique à travers une forme simple où les végétaux ont leur propre personnalité. Ce conte transforme de façon ludique le rapport que les enfants entretiennent avec les légumes afin de rendre l'alimentation plus saine et amusante. Un conte pour aider les parents dans la difficile tâche de rendre appétissants les fruits et les légumes aux plus petits à l'Ère numérique. C'est un conte simple, avec des rimes cadencées, idéal pour un spectacle théâtral à l'école également.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        pedro marangoni, Isadora Fouraux et William Sessa
      </h2>
      
      <p class="authorDescription body article">De Pedro Marangoni, auteur brésilien de contes enfantins très accessible et adaptés pour tous les enfants à partir de 4 ans.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dark
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c1b9f538